import React, { FC } from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Box } from '@mui/material';
import { CongratsIcon } from '../../vectors/index';

type WotcSurveyCompleteCongratulationsModalProps = {
  congratulationsModal: boolean;
  handleClose: () => void;
};

const WotcSurveyCompleteCongratulationsModal: FC<
  WotcSurveyCompleteCongratulationsModalProps
> = ({ congratulationsModal, handleClose }) => {
  return (
    <Dialog
      open={congratulationsModal}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', right: 8, top: 8 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="10px"
        >
          <CongratsIcon />
          <Typography variant="h5">Survey Completed</Typography>
        </Box>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <Button onClick={handleClose} variant='contained'>Close</Button>
        </Stack>
      </DialogTitle>
    </Dialog>
  );
};

export default WotcSurveyCompleteCongratulationsModal;
